import { MaterialUICore } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const ImageWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
});
